"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const AttributesTable = ({ attributesKeys, attributesObject, defaultRowsCount, showAllAttributes, }) => {
    const shownAttributesKeys = React.useMemo(() => (showAllAttributes ? attributesKeys : attributesKeys.slice(0, defaultRowsCount)), [attributesKeys, defaultRowsCount, showAllAttributes]);
    return ((0, jsx_runtime_1.jsx)("table", { className: "table w-full", children: (0, jsx_runtime_1.jsx)("tbody", { children: shownAttributesKeys.map(item => ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: item }), (0, jsx_runtime_1.jsx)("td", { children: attributesObject[item] })] }, `${item}-${attributesObject[item]}`))) }) }));
};
exports.AttributesTable = AttributesTable;
